import {Component, EventEmitter, Input, Output} from "@angular/core";
import {MatRadioChange} from "@angular/material";

@Component({
  selector: 'app-radio-field',
  template: `
    <mat-radio-button
      [value]="value"
      (change)="handleChange.emit($event)"
      [checked]="checked"
      color="primary">
      <ng-content></ng-content>
    </mat-radio-button>
  `,
  styles: [
    `
      :host ::ng-deep .mat-radio-button .mat-radio-outer-circle {
        border-width: 1px;
      }
    `
  ]
})
export class RadioFieldComponent {
  @Input() value: string;
  @Input() checked: boolean;

  @Output() handleChange: EventEmitter<MatRadioChange> = new EventEmitter<MatRadioChange>();


}



// WEBPACK FOOTER //
// ./src/app/components/form-fields/radio-field/radio-field-component.ts